/**
 * @file Progress Bar
 */

import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

/**
 * Progress Bar component
 */
const vProgressBar = () => {
	const progressBar = document.querySelector( '.v-progress-bar' );

	if ( ! progressBar ) {
		return;
	}

	gsap.registerPlugin( ScrollTrigger );

	const bar         = progressBar.querySelector( '.v-progress-bar__bar' );
	const triggerVars = {
		trigger:       bar,
		toggleActions: 'play none none reset',
	};
	const defaults    = { duration: 1, ease: 'power1.inOut' };
	const barFrom     = { scaleX: 0.1 };
	const barTo       = { scaleX: ( bar.dataset.progress.length ? bar.dataset.progress : .75 ) };

	gsap.timeline( {
		scrollTrigger: {
			start: 'top bottom-=10%',
			...triggerVars,
		},
		defaults,
	} )
		.fromTo( bar, barFrom, barTo );
};

export default vProgressBar;
